import { FlatTreeControl } from '@angular/cdk/tree';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { LazyCatalog } from 'compob2b-libs';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { CustomerCatalogService } from '../services/customer-catalog.service';
import { CatalogMobileSelectorService } from '../services/catalog-mobile-selector.service';
import { CustomerDynamicDataSource } from '../modal-catalog/customer-dynamic-data-source';

const ROOT_TITLE = 'Каталог';

@Component({
  selector: 'app-catalog-level-selector',
  templateUrl: './catalog-level-selector.component.html',
  styleUrls: ['./catalog-level-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CatalogLevelSelectorComponent implements OnInit, OnDestroy {
  readonly title = ROOT_TITLE;

  isOpen = false;
  treeControl: FlatTreeControl<LazyCatalog>;
  dataSource: CustomerDynamicDataSource;

  private readonly unsubscribe = new Subject<boolean>();

  constructor(private readonly catalogService: CustomerCatalogService,
              private readonly catalogMobileSelectorService: CatalogMobileSelectorService,
              private readonly cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.treeControl = new FlatTreeControl<LazyCatalog>(this.getLevel, this.isExpandable);
    this.dataSource = new CustomerDynamicDataSource(this.treeControl, this.catalogService, this.unsubscribe);

    this.catalogService.initCatalogTree()
      .pipe(take(1))
      .subscribe(tree => {
        this.dataSource.data = tree;
        this.cdr.markForCheck();
      });

    this.catalogMobileSelectorService.getOpenSelector()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(() => this.open());
  }

  ngOnDestroy(): void {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }

  getLevel = (node: LazyCatalog) => node.level;

  isExpandable = (node: LazyCatalog) => !node.lastLevel;

  open(): void {
    this.isOpen = true;
    this.cdr.markForCheck();
  }

  close(): void {
    this.isOpen = false;
    this.cdr.markForCheck();
  }
}
